import React from 'react';
import PropTypes from 'prop-types';

import {AppContext} from '../../AppModule/Context';

import NotificationComponent from './../common/genericComponents/notificationComponent';

import VIDABOO_CONSTANTS from '../../config/consts';
import audioFileService from '../../services/audioFileService';
import {ListeningRoomService} from '../../services/websocketService';
import postMessageService from '../../services/postMessageService';
import ResourcePermissionsService from '../../services/resourcePermissionsService';

const propTypes = {
  currentUser: PropTypes.object,
  extendedMentorDto: PropTypes.object,
  startVideochatFromEngager: PropTypes.func,
  changeIframeSize: PropTypes.func,
};

export default class EngagerReceiverComponent extends React.Component {
  constructor() {
    super();
    this.state = {};
    this.constraints = {
      audio: true,
      video: true,
    };
  }
  componentDidMount = () => {
    this.registerListeners();
  };
  componentDidUpdate(prevProps) {
    if (
      prevProps.permissionsStatusesObj !== this.props.permissionsStatusesObj &&
      this.props.permissionsStatusesObj
    ) {
      if (
        this.getIsRequiredPermissionsForCallGranted(
          this.props.permissionsStatusesObj,
        )
      ) {
        this.props.setShowPermissionsPopup(false);
      }
    }
  }
  componentWillUnmount = () => {
    this.deleteDoWhenMessageReceivedFromListeningRoom();
    this.callAudio?.removeEventListener(
      'loadedmetadata',
      this.handleLoadMetaData,
    );
  };
  registerListeners = () => {
    this.deleteDoWhenMessageReceivedFromListeningRoom =
      ListeningRoomService.doWhenMessageReceivedFromListeningRoom((data) => {
        if (
          data.messageType === VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER
        ) {
          if (
            data.content.SubType ===
            VIDABOO_CONSTANTS.ENGAGER_SUBTYPES.INTERACTION_REQUEST
          ) {
            this.setState({sessionMode: data.content.sessionMode});
            this.props?.widgetContext?.setEngagerReqId(
              data.content.engagerReqId,
            );
            this.startReceivedInteractionRequestFlow();
          }
        }
      });
  };

  startReceivedInteractionRequestFlow = () => {
    const messageToSend = {
      SubType:
        VIDABOO_CONSTANTS.ENGAGER_SUBTYPES.ENDPOINT_RCVD_INTERACTION_REQUEST,
    };
    ListeningRoomService.publishToListeningRoom(
      messageToSend,
      this.props.currentUser.userId,
      this.props.extendedMentorDto.mentorDto.mentorOwnerId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
    );
    if (
      postMessageService.getWidgetSize() !== VIDABOO_CONSTANTS.WIDGET_SIZE.LARGE
    )
      this.props.changeIframeSize(
        VIDABOO_CONSTANTS.WIDGET_SIZE.WIDGET_OPEN,
        'engager',
        'visible',
      );
    this.setState({
      showNotificationPopup: true,
      notificationText: this.context.languageSet.ACTIVE_AGENT.CALL_REQUEST, //"you have a call request",
      notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.DARK,
      popupAcceptBtnFunc: this.handlePermissionsAndAcceptCall,
      popupAcceptBtnText: this.context.languageSet.ACTIVE_AGENT.ACCEPT,
      popupRejectBtnFunc: this.rejectCall,
      popupRejectBtnText: this.context.languageSet.ACTIVE_AGENT.DECLINE,
      popupCloseBtnFunc: null,
      popupCloseBtnText: null,
    });

    this.callAudio = audioFileService.playOrGetAudioFile(
      VIDABOO_CONSTANTS.AUDIO_SOUND_TYPES.CALL_AUDIO,
      true,
    );
    this.callAudio.addEventListener('loadedmetadata', this.handleLoadMetaData);
  };
  handleLoadMetaData = () => {
    this.ring();
  };
  playSound = () => {
    //audio.play();
    var promise = this.callAudio.play();

    if (promise !== undefined) {
      promise
        .then(() => {
          // Autoplay started!
        })
        .catch(() => {
          // Show something in the UI that the video is muted
          // this.callAudio.play();
        });
    }
  };
  stopSound = () => {
    this.callAudio.pause();
    this.callAudio.currentTime = 0;
  };

  ring = () => {
    if (!this.soundInterval) {
      this.soundInterval = setInterval(() => {
        // console.debug('ring ring... ring ring...');

        this.playSound();
      }, 1100);
    }
  };
  stopRing = () => {
    if (this.soundInterval) clearInterval(this.soundInterval);
    this.soundInterval = null;
    this.stopSound();
  };

  rejectCall = () => {
    this.stopRing();
    const messageToSend = this.createMessageData(
      VIDABOO_CONSTANTS.CALL_RESPONSE_STATES.REJECT,
      VIDABOO_CONSTANTS.ENGAGER_SUBTYPES.RESPONSE_TO_INTERACTION_REQUEST,
    );
    ListeningRoomService.publishToListeningRoom(
      messageToSend,
      this.props.currentUser.userId,
      this.props.extendedMentorDto.mentorDto.mentorOwnerId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
    );

    this.closePopup();
  };

  handlePermissionsAndAcceptCall = async () => {
    this.props.setIsCallAudioOnly(false);
    // try {
    try {
      await ResourcePermissionsService.loudGetPermissions(this.constraints);
      let permissionsStatusesObj = {...this.props.permissionsStatusesObj};
      permissionsStatusesObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA] =
        VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED;
      permissionsStatusesObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE] =
        VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED;
      this.props.setPermissionsStatusesObj(permissionsStatusesObj);
      this.props.setShowPermissionsPopup(false);
      this.stopRing();
      this.acceptCall();
    } catch (error) {
      this.props.setShowPermissionsPopup(true);
      console.debug('Error: ', error);
    }
    // } catch (error) {
    //   // if quiet permission not supported
    //   console.debug('Error: ', error);
    //   try {
    //     await ResourcePermissionsService.loudGetPermissions(this.constraints);
    //     let permissionsStatusesObj = {...this.props.permissionsStatusesObj};
    //     permissionsStatusesObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA] =
    //       VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED;
    //     permissionsStatusesObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE] =
    //       VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED;
    //     this.props.setPermissionsStatusesObj(permissionsStatusesObj);
    //     this.props.setShowPermissionsPopup(false);
    //     this.acceptCall();
    //   } catch (error) {
    //     this.props.setShowPermissionsPopup(true);
    //     console.debug('Error: ', error);
    //   }
    // }
  };

  acceptCall = () => {
    this.stopRing();
    const messageToSend = this.createMessageData(
      VIDABOO_CONSTANTS.CALL_RESPONSE_STATES.ACCEPT,
      VIDABOO_CONSTANTS.ENGAGER_SUBTYPES.RESPONSE_TO_INTERACTION_REQUEST,
    );
    ListeningRoomService.publishToListeningRoom(
      messageToSend,
      this.props.currentUser.userId,
      this.props.extendedMentorDto.mentorDto.mentorOwnerId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
    );
    this.props.startVideochatFromEngager(this.state.sessionMode);

    this.closePopup();
  };

  createMessageData = (messageContent, subtype) => {
    return {
      SubType: subtype
        ? subtype
        : VIDABOO_CONSTANTS.ENGAGER_SUBTYPES.RESPONSE_TO_INTERACTION_REQUEST,
      // senderProfileName: this.props.currentUser.profileName,
      senderUserId: this.props.currentUser.userId,
      message: messageContent,
      senderCreationTime: new Date().getTime(),
    };
  };
  closePopup = () => {
    this.setState({
      showNotificationPopup: false,
    });
  };

  getIsRequiredPermissionsForCallGranted = (permissionsStatusesObj) => {
    return (
      permissionsStatusesObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.MICROPHONE] ===
        VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED &&
      permissionsStatusesObj[VIDABOO_CONSTANTS.PERMISSION_TYPES.CAMERA] ===
        VIDABOO_CONSTANTS.PERMISSION_STATUS.GRANTED
    );
  };

  render() {
    return (
      <div>
        {this.state.showNotificationPopup && (
          <NotificationComponent
            notificationTxt={this.state.notificationText}
            acceptBtnTxt={this.state.popupAcceptBtnText}
            acceptBtnFunc={this.state.popupAcceptBtnFunc}
            rejectBtnTxt={this.state.popupRejectBtnText}
            rejectBtnFunc={this.state.popupRejectBtnFunc}
            closeBtnTxt={this.state.popupCloseBtnText}
            closeBtnFunc={
              this.state.popupCloseBtnFunc
                ? this.state.popupCloseBtnFunc
                : this.closePopup
            }
          />
        )}
      </div>
    );
  }
}
EngagerReceiverComponent.contextType = AppContext;
EngagerReceiverComponent.propTypes = propTypes;
